import BaseViewExtensionViewFactory from '@/Factories/ViewFactories/BaseViewExtensionViewFactory';
import ComponentManager from '@/Management/ComponentManager';

export default class SettingsViewFactory extends BaseViewExtensionViewFactory {

    public constructor(params: any) {
        let newParams = $.extend({
            ErgName: 'OPTIONS_LANDSCAPE_TITLE',
            viewElementName: 'Settings',
            viewModelName: 'SettingsViewModel',
            viewName: 'SettingsView'
        }, params);

        super(newParams);
    }
}

ComponentManager.setFactory('Settings', SettingsViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');